import _asyncToGenerator from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/regenerator/index.js";
import { Uint8ArrayBlobAdapter } from "@smithy/util-stream";
export var collectBody = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var streamBody,
      context,
      fromContext,
      _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            streamBody = _args.length > 0 && _args[0] !== undefined ? _args[0] : new Uint8Array();
            context = _args.length > 1 ? _args[1] : undefined;
            if (!(streamBody instanceof Uint8Array)) {
              _context.next = 4;
              break;
            }
            return _context.abrupt("return", Uint8ArrayBlobAdapter.mutate(streamBody));
          case 4:
            if (streamBody) {
              _context.next = 6;
              break;
            }
            return _context.abrupt("return", Uint8ArrayBlobAdapter.mutate(new Uint8Array()));
          case 6:
            fromContext = context.streamCollector(streamBody);
            _context.t0 = Uint8ArrayBlobAdapter;
            _context.next = 10;
            return fromContext;
          case 10:
            _context.t1 = _context.sent;
            return _context.abrupt("return", _context.t0.mutate.call(_context.t0, _context.t1));
          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function collectBody() {
    return _ref.apply(this, arguments);
  };
}();